import { TextQuestion } from "./text-question";
import type { QuestionTypeRendererProps } from "./shared";

type LongAnswerQuestionProps = QuestionTypeRendererProps<"long_answer">;

export default function LongAnswerQuestionType(props: LongAnswerQuestionProps) {
  return <TextQuestion {...props} kind="long_answer" />;
}
